import React, { useMemo } from 'react';
import { AlphaFeedBox, AlphafeedFullIcon, AlphafeedMobileIcon } from './HypertrackerSidebarStyled';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { ROUTES } from '@/lib/constants/routes';

const AlphafeedItem = ({ open, isSelected, t }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const onClick = () => {
        navigate(ROUTES.HYPERTRACKER_ALPHAFEED);
    };

    const boxColor = useMemo(() => {
        if (open) {
            return theme.palette.primitives.sun[500];
        }

        return isSelected
            ? theme.palette.primitives.sun[1000]
            : 'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #000';
    }, [theme, open, isSelected]);

    return (
        <React.Fragment>
            <Typography
                data-testid="hypertracker-sidebar-alphafeed-group-label"
                variant={'p12'}
                color={theme.palette.primitives.woodsmoke[700]}
                textAlign={open ? 'unset' : 'center'}
                component={'p'}
                width={'100%'}
                sx={{
                    padding: '0 18px',
                    margin: '16px 0 4px',
                }}
            >
                {t(!open ? 'group_trade_short' : 'group_trade')}
            </Typography>

            <AlphaFeedBox
                data-testid="hypertracker-sidebar-alphafeed-item"
                role="button"
                onClick={onClick}
                sx={{
                    width: !open ? '40px' : '92%',
                    background:
                        !open && isSelected ? theme.palette.primitives.sun[1000] : undefined,
                    backgroundColor: boxColor,
                    marginRight: open ? '16px' : '10px',
                }}
            >
                {open ? (
                    <AlphafeedFullIcon />
                ) : (
                    <AlphafeedMobileIcon
                        sx={{
                            path: {
                                fill: isSelected
                                    ? theme.palette.primitives.sun[500]
                                    : theme.palette.primitives.woodsmoke[500],
                            },
                        }}
                    />
                )}
            </AlphaFeedBox>
        </React.Fragment>
    );
};

export default AlphafeedItem;
